import React, {useEffect, useRef, useState} from 'react';
import {Button, Card, Checkbox, Col, Flex, Form, Input, List, Row, Select, Space} from "antd";
import {StyledPopUp} from "../../../../shared";
import { PropertiesPopupProps} from "../../models";
import {useForm} from "antd/es/form/Form";
import {StyledCard} from "./PropertiesPopup.styled";
import {useLocation} from "react-router-dom";
import {connect} from "react-redux";
import {getProductAssurance, getProductProperties} from "../../actions/AdInsert.action";
import {withRouter} from "../../../../utils/services/with-router";
const { TextArea } = Input;


const PropertiesPopup = ({open, onCansel,getProductProperties,onConfirm}: PropertiesPopupProps) => {

    const [form] = useForm();
    const [propertiesData, setPropertiesData] = useState<any[]>([])
    const [loading, setLoading] = useState<boolean>(false);
    const location =useLocation()
    const getList = () => {
        getProductProperties(location.state.stepOneForm.subCategoryId)
            .then((data: any) => {
                if (data.payload != undefined) {
                    let tempData = data.payload.data.map((item:any,index:any) => ({
                        name : item.name,
                        productPropertyTemplateId : item.id,
                        isChecked : location.state?.stepTwoForm?.productAssurances?.[index]?.isChecked || false,
                        value: location.state?.stepTwoForm?.productProperties?.[index]?.value || "",
                        id : item.id,
                    }))
                    form.setFieldsValue({properties: tempData})
                    setPropertiesData(tempData);

                    setLoading(false);
                } else {
                    setLoading(false);
                }
            })
            .catch((e: any) => {
            });
    };
    useEffect(() => {
        getList();
    }, []);
    const onFinish = (value: any) => {
        onConfirm(value.properties.filter((item:any) => item.value !== undefined && item.value !== "" && item.value !== " "))
        onCansel()
    }


    return (
        <StyledPopUp
            open={open}
            onCancel={onCansel}
            title={
            <div style={{ display: "flex", flexDirection: "column" }}>
                <span style={{ fontSize: "18px", fontWeight: 600 }}>ویژگی‌ها و جزئیات محصول</span>
                <span style={{ fontSize: "12px", color: "#818181ff", marginTop: "4px" }}>
💡 از بین مشخصات زیر، هر چیزی که برای محصولتان مهم است را وارد کنید. پر کردن هر مورد اختیاری است و فقط موارد تکمیل شده نمایش داده می‌شوند.
اگر مشخصه‌ای در لیست نیست، می‌توانید آن را در توضیحات آگهی خود بنویسید.
</span>
            </div>
            }
            width={"100%"}
            footer={null}
            transitionName={''}

        >
            <Flex vertical gap={"small"}>
                <Form layout={"vertical"} form={form} onFinish={onFinish} >

                        <Flex vertical style={{maxHeight:"400px" , overflowY:"auto"}}>
                            <Col xs={23} sm={23} md={23} lg={23} xl={23}>

                            <Form.List name="properties">
                                {(fields, { add, remove }) => (
                                    <>
                                        {fields.map(({ key, name, ...restField }) => (
                                            <StyledCard>
                                            <Flex vertical  style={{marginBottom:"15px"}}>
                                                <Form.Item
                                                    {...restField}
                                                    name={[key, 'value']}
                                                    label={propertiesData[key].name}
                                                >
                                                    <TextArea
                                                        placeholder={'توضیحات'}

                                                        rows={3}
                                                    />
                                                </Form.Item>

                                            </Flex>
                                            </StyledCard>
                                        ))}
                                    </>
                                    )}
                            </Form.List>
                            </Col>
                        </Flex>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Row justify={"center"}>
                            <Button size={"large"} type="primary" block htmlType={"submit"}
                            >انتخاب کنید</Button>
                        </Row>
                    </Col>

                </Form>
            </Flex>
        </StyledPopUp>
    );
};

export default connect(null, {getProductProperties})(withRouter(PropertiesPopup));
